import { create } from 'zustand';
import { shallow } from 'zustand/shallow';
import { RegisterPersonalDetailsData } from '@/lib/validation';

type State = {
  personalDetails: RegisterPersonalDetailsData | null;
};

type Actions = {
  setData: (data: Partial<State>) => void;
  resetData: (data?: (keyof State)[]) => void;
};

const initialState: State = {
  personalDetails: null,
};

const useRegisterStoreBase = create<State & Actions>()(set => ({
  ...initialState,
  setData: data =>
    set(state => ({
      ...state,
      ...data,
    })),
  resetData: data =>
    set(state => {
      if (!data) return initialState;

      data.forEach((name: string) => {
        if (Object.prototype.hasOwnProperty.call(initialState, name)) {
          state[name] = initialState[name];
        }
      });

      return state;
    }),
}));

export const useRegisterStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useRegisterStoreBase(selector, shallow);
};
